const routerWebViewAerial = {
  path: "/mobile/webView",
  name: "webView",
  component: () => import("@/webViewAerial/home.vue"),
  children: [
    // 嵌入到第三方的页面
    {
      path: "aerialPoint",
      name: "mobile_viewWeb_aerialPoint",
      component: () => import("@/webViewAerial/aerialPoint"),
      meta: { name: "航拍点攻略" }
    },
    {
      path: "addressList",
      name: "mobile_viewWeb_addressList",
      component: () => import("@/webViewAerial/addressList"),
      meta: { name: "地点" }
    },
    {
      path: "updataArticle",
      name: "mobile_viewWeb_updataArticle",
      component: () => import("@/webViewAerial/updataArticle"),
      meta: { name: "发布内容" }
    },
    {
      path: "demoContent",
      name: "mobile_viewWeb_demoContent",
      component: () => import("@/webViewAerial/demoContent"),
      meta: { name: "飞行点内容" }
    },
  ]
}

export default routerWebViewAerial;



// WEBPACK FOOTER //
// ./src/router/routerWebViewAerial.js